<template>
  <section class="heatExchanger">
    <p><b>Навесной котёл VITOPEND</b> - ремонт/промывка теплообменника нецелесообразна, стоимость работ соизмерима со стоимостью нового котла.</p>
    <p><b>Навесной конденсационный котёл VITODENS</b> - рекомендуется промывка теплообменника специальным раствором. Стоимость работ по промывке теплообменника котла мощностью 25-80 кВт: <span class="red">10 000 руб</span> ; мощностью более 80 кВт: <span class="red">15 000 руб</span>. <br> </p>
    <p><b>Чугунные секционные котлы VITOGAS, VITOROND</b> - ремонт, замена чугунных секций котла выполняется на месте, необходимо специальное оборудование. Стоимость работ по ремонту теплообменника котла мощностью 35-60 кВт: <span class="red">15 000 руб</span>; мощностью 72-140 кВт: <span class="red">20 000 руб</span>.</p>
    <app-document>
      <h1 class="docHeader">Ремонт чугунного теплообменника</h1>
      <template v-slot:pdf>
        <a href="https://drive.google.com/file/d/1jLNGt0n7t4NNOSY454LpxnwkEZ3fvf1u/view?usp=sharing" target="_blank">
          <img class="docImg" src="../img/pdf.webp" alt="иконка пдф">
        </a>
      </template>
    </app-document>
    <div class="figures">
    <figure>
      <img src="../img/heatExchanger.webp" alt="теплообменник">
      <figcaption>Теплообменник</figcaption>
    </figure>
     <figure>
       <img src="../img/section.webp" alt="секция чугунного теплообменника">
       <figcaption>Секция чугунного теплообменника</figcaption>
     </figure>
    </div>
    <p id="section">При образовании на внутренней поверхности секций отложений, при их замене <span>высока вероятность критических повреждений</span> оставшихся секций. В таком случае рекомендуется замена всего теплообменника. Промывка внутренней поверхности чугунного теплообменника неэффективна, и приводит только к лишним тратам перед неизбежной заменой. </p>

  </section>
</template>

<script>
  import AppDocument from "@/components/AppDocument";

  export default {
    components: {AppDocument}
  }
</script>

<style scoped>

.heatExchanger {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.figures {
  display: flex;
  justify-content: space-around;
  width: 100%;
  height: 70vh;
  margin-top: 20px;
}

p {
  text-indent: 50px;
  font-size: 2em;
  padding: 10px;
  margin: 15px 5%;
}

figure {
  text-align: center;
}

figcaption {
  font-size: 2em;
  margin-bottom: 30px;
}

img {
  width: 80%;
  height: 100%;
}

h2 {
  text-align: center;
}

#section {
  text-align: justify;
  margin-top: 30px;
  margin-bottom: 50px;
}

span {
  color: red;
  font-weight: 700;
}

h1 {
  font-family: "Poppins", sans-serif !important;
  color: black;
}

a {
  text-transform: uppercase;
}

@media (max-width: 1400px) {
  .figures {
    flex-direction: column;
    height: auto;
  }
}

@media (max-width: 900px) {
  p {
    font-size: 1.5em;
  }
}

@media (max-width: 400px) {
  figure {
    margin: 0;
  }

  figcaption {
    font-size: 1.5em;
  }

  p {
    font-size: 1em;
    margin-bottom: 0;
    margin-top: 0;
  }

  #section {
    margin-top: 0;
    margin-bottom: 10px;
  }
}

</style>